import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[kbDialogContentHost]',
    standalone: false
})
export class DialogContentHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}